// src/stores/tempFiles.js
const stash = new Map();

export function stashFile(file) {
  const id = (crypto.randomUUID?.() ?? Math.random().toString(36).slice(2));
  stash.set(id, file);
  return id;
}
export function takeFile(id) {
  const f = stash.get(id);
  stash.delete(id);
  return f || null;
}
